import suiteService from 'qreventos-suite/services';
import pagosService from 'qreventos-suite/pagos'
import invitacionService from 'qreventos-suite/invitaciones';

class SuiteConfig {
  evento: number = 827;
  token: string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4SSt4d09sd2VOSjg4WkF5WUZtTS9rTT0=';
  clientId: string = 'acb5e13b-3769-4c47-9bf0-978a1b566c95-827';

  public constructor() {
    suiteService.clientId = this.clientId;
    suiteService.token = this.token;

    pagosService.clientId = this.clientId;
    pagosService.token = this.token;

    invitacionService.clientId = this.clientId;
    invitacionService.token = this.token;
  }
}

export default new SuiteConfig();